/**
 * Choix du bandeau cookies (Sentry + PostHog).
 *
 * La CNIL recommande de garder le choix, accord comme refus, environ 6 mois puis de le
 * redemander. Un choix enregistré sans date (avant novembre 2026) est donc redemandé.
 */
export const COOKIE_CONSENT_KEY = "equiply_cookie_consent";
export const COOKIE_CONSENT_AT_KEY = "equiply_cookie_consent_at";
const COOKIE_CONSENT_MAX_AGE_DAYS = 182;

/** Rouvre le bandeau, pour modifier ou retirer son choix. */
export const OPEN_COOKIE_SETTINGS_EVENT = "equiply:open-cookie-settings";

export type CookieConsent = "accepted" | "rejected";

const MAX_AGE_MS = COOKIE_CONSENT_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;

/** Choix en cours de validité, ou null s'il faut (re)poser la question. */
export function readCookieConsent(now: number = Date.now()): CookieConsent | null {
  try {
    const value = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (value !== "accepted" && value !== "rejected") return null;
    const savedAt = Date.parse(localStorage.getItem(COOKIE_CONSENT_AT_KEY) ?? "");
    if (Number.isNaN(savedAt) || now - savedAt > MAX_AGE_MS) return null;
    return value;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent(now: number = Date.now()): boolean {
  return readCookieConsent(now) === "accepted";
}

export function saveCookieConsent(choice: CookieConsent, now: Date = new Date()): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, choice);
    localStorage.setItem(COOKIE_CONSENT_AT_KEY, now.toISOString());
  } catch {
    // Stockage indisponible (navigation privée) : le bandeau reviendra à la prochaine visite.
  }
}

export function openCookieSettings(): void {
  window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
}
